<div class="modal-container">
    <!-- <div class="bg">
        <svg width="100%" height="100%" viewBox="0 0 520 460" preserveAspectRatio="xMidYMid slice">
            <g #modalContour stroke="#1FA47A" fill="none" stroke-width="0.7">
            </g>

            <g #modalOrb stroke="#68DAFF" fill="none">
            </g>
        </svg>
        <div class="glow"></div>
    </div> -->

    <button class="x" (click)="closeModal()">
        &times;
    </button>

    <div class="inner">
        <img class="lock img-fluid d-block" src="assets/images/png/modal-logo.png" alt="Lock Icon">
        <span class="eyebrow">
            <span class="dot"></span>
            {{ heading }}
        </span>

        <h2 class="title">{{"intent_modal.para" | translate}}</h2>
        <div class="price-row">
            <div class="pc">
                <div class="l">{{"intent_modal.current_price" | translate}}</div>
                <div class="v blue">${{ salePrice | number:'1.4-6' }}</div>
            </div>
            <div class="pc">
                <div class="l">{{"intent_modal.target_listing" | translate}}</div>
                    <div class="v lime">
                       {{"intent_modal.target_listing_price" | translate}}
                        <!-- ${{ targetListing | number:'1.2-6' }} -->
                    </div>
            </div>
            <div class="pc">
                <div class="l">{{"intent_modal.potential" | translate}}</div>
                <div class="v">100x</div>
            </div>
        </div>

        <div class="cd" *ngIf="+eventService.daysCounter()._diff > 0">
            {{"intent_modal.next_price" | translate}}  <b id="cd1"> {{ liveCounter()._days }}D</b> : <b id="cd2">{{ liveCounter()._hours }}H</b> : <b id="cd3">{{ liveCounter()._minutes }}M</b> 
            : <b id="cd4">{{ liveCounter()._seconds }}S</b>
        </div>
        <div class="cd" *ngIf="!(+eventService.daysCounter()._diff > 0)">
            {{"intent_modal.next_price" | translate}} <b>{{ 'banner.coming_soon' | translate }}</b>
        </div>

        <button class="buy" (click)="onBuyClick()">
           {{"intent_modal.buy_now" | translate}}
        </button>

        <button class="skip" (click)="closeModal()">
            {{"intent_modal.skip" | translate}}
        </button>
    </div>
</div>